import { render } from "./objectCreationComponent.vue?vue&type=template&id=70dab56e&scoped=true"
import script from "./objectCreationComponent.vue?vue&type=script&lang=js"
export * from "./objectCreationComponent.vue?vue&type=script&lang=js"

import "./objectCreationComponent.vue?vue&type=style&index=0&id=70dab56e&scoped=true&lang=css"

import exportComponent from "C:\\Users\\Anupashyam\\Downloads\\gitlabs - rel path oops\\virtuallab-oop\\exp-9\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-70dab56e"]])

export default __exports__